import Modal from '~/javascripts/components/Modal';

const ConsentInfoModal = ({ includeMail, includeSms, modalId }) => {
  const methods = () => {
    if (includeMail && includeSms) {
      return 'mail, text message, and email';
    } else if (includeSms) {
      return 'text message and email';
    } else if (includeMail) {
      return 'mail and email';
    } else {
      return 'email';
    }
  };

  const innerText = `
    We’ll send you marketing communications via ${methods()}. You can change your preferences at any time.
  `;

  return (
    <Modal modalId={modalId} modalInnerClassName='consent-info-modal'>
      <p>{innerText}</p>
    </Modal>
  );
};

export default ConsentInfoModal;
